import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/graphql'
import { Schema } from '../../forms/GeneralPageForm'
import { toDTO } from './api/mapper'
import { UPSERT_WORKSPACE_AMAZON } from './api/mutation'
import { Data } from './api/types'
import { UseUpsertWorkspaceAmazon } from './types'

export const useUpsertWorkspaceAmazon = (): UseUpsertWorkspaceAmazon => {
  const { t } = useTranslation('features/globalSetup/amazon', { keyPrefix: 'pages.general.upsert' })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const [mutate, { loading }] = useMutation(UPSERT_WORKSPACE_AMAZON, {
    onCompleted: ({ upsertWorkspaceAmazon: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))

        enqueueSnackbar(t('error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    refetchQueries: ['getWorkspaceAmazon'],
  })

  const upsert = (data: Schema): void =>
    void mutate({
      variables: {
        input: toDTO(data),
      },
    })

  return {
    errors,
    loading,
    upsert,
  }
}
